import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { NavItem } from "../common-types";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { Subject, takeUntil } from "rxjs";
import { Store } from "@ngrx/store";
import { messagesFeature, MessagesState } from "../messages/store/messages.reducer";
import { selectUnseenMessageCount } from "../messages/store/messages.selectors";
import { MessagesAction } from "../messages/store/messages.action";
import { SocketService } from "../../../../../core/src/lib/soket/socket.service";
import { MhNotificationType, MhSocketMessage } from "../../api/notification/notification.types";
import { Router } from "@angular/router";
import { selectTalentProfileCompleteness } from "../../api/profile/store/talent-profile.selectors";
import { TalentProfileCompleteness } from "../../api/dashboard/dashboard.types";
import { talentProfileFeatureName, TalentProfileState } from "../../api/profile/store/talent-profile.reducer";

@Component({
  selector: "mh-header-nav-item",
  templateUrl: "./header-nav-item.component.html",
  styleUrls: ["./header-nav-item.component.less"],
})
export class HeaderNavItemComponent implements OnInit, OnDestroy {
  @Input() navItem!: NavItem;
  badgeCount: number | undefined | NzSafeAny;
  profileCompleteness?: TalentProfileCompleteness;
  private conversationId?: string | null;
  private isInboxPage = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly store: Store<{ [messagesFeature]: MessagesState, [talentProfileFeatureName]: TalentProfileState }>,
    private socketService: SocketService,
    private router: Router,
  ) {}

  ngOnInit() {
    if (this.navItem?.badgeType == "unseenMessages") {
      this.store
        .select(selectUnseenMessageCount)
        .pipe(takeUntil(this.destroy$))
        .subscribe((count) => (this.badgeCount = count));
      this.store.dispatch(MessagesAction.getUnseenMessageCount());
      this.socketService.messages$.pipe(takeUntil(this.destroy$)).subscribe((message: MhSocketMessage) => {
        this.checkCurrentUrl();
        if (
          message.action === MhNotificationType.COMMUNICATION_MESSAGE
          && !this.conversationId && message.message?.conversationId !== this.conversationId
          &&!this.isInboxPage
        ) {
          this.store.dispatch(MessagesAction.increaseUnseenMessageCount());
        }
      });
    }
    if (this.navItem?.badgeType == "profileFilledOut") {
      this.store
        .select(selectTalentProfileCompleteness)
        .pipe(takeUntil(this.destroy$))
        .subscribe((profileCompleteness) => (this.profileCompleteness = profileCompleteness));
    }
  }

  private checkCurrentUrl() {
    const url = this.router.url;
    this.conversationId = url?.includes("inbox/conversation") ? url.substring(url.lastIndexOf("/") + 1) : "";
    this.isInboxPage = url?.endsWith("/inbox");
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}
